// extracted by mini-css-extract-plugin
export var container = "_j7-0";
export var content = "_j7-3";
export var customerTitle = "_j7-4";
export var empty = "_j7-5";
export var gray = "_j7-6";
export var header = "_j7-7";
export var info = "_j7-8";
export var loading = "_j7-2";
export var loadingCard = "_j7-9";
export var oneLine = "_j7-a";
export var personName = "_j7-e";
export var pillContainer = "_j7-b";
export var selected = "_j7-1";
export var text = "_j7-c";
export var twoLines = "_j7-d";
export var unread = "_j7-f";
export var unreadIndicator = "_j7-g";